import {getParentStructurePath} from '../../Common/PropertyPaths';

//Accident surgeries
export const getAccidentSurgeriesPath = (planIndex: number = 0, coverageIndex: number = 0) => {
  const parentPath = getParentStructurePath(planIndex, coverageIndex);
  return {
    unitsOfAccAccidentSurgeries: `${parentPath}.unitsOfAccAccidentSurgeries`,
    isMiscellaneousOutpatientSurgeryApplied: `${parentPath}.isMiscellaneousOutpatientSurgeryApplied`,
    miscellaneousOutpatientSurgeryDetails: {
      incurralPeriod: `${parentPath}.miscellaneousOutpatientSurgeryDetails.incurralPeriod`,
      benefitAmount: `${parentPath}.miscellaneousOutpatientSurgeryDetails.benefitAmount.amount`,
      maxBenefitNumber: `${parentPath}.miscellaneousOutpatientSurgeryDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.miscellaneousOutpatientSurgeryDetails.timePeriodCd`,
    },
    isOpenAbdominalOrThoracicSurgeryApplied: `${parentPath}.isOpenAbdominalOrThoracicSurgeryApplied`,
    openAbdominalOrThoracicSurgeryDetails: {
      incurralPeriod: `${parentPath}.openAbdominalOrThoracicSurgeryDetails.incurralPeriod`,
      benefitAmount: `${parentPath}.openAbdominalOrThoracicSurgeryDetails.benefitAmount.amount`,
      maxBenefitNumber: `${parentPath}.openAbdominalOrThoracicSurgeryDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.openAbdominalOrThoracicSurgeryDetails.timePeriodCd`,
    },
    isTendonLigamentRotatorCuffApplied: `${parentPath}.isTendonLigamentRotatorCuffApplied`,
    tendonLigamentRotatorCuffDetails: {
      incurralPeriod: `${parentPath}.tendonLigamentRotatorCuffDetails.incurralPeriod`,
      withoutRepairAmount: `${parentPath}.tendonLigamentRotatorCuffDetails.withoutRepairAmount.amount`,
      withRepairAmount: `${parentPath}.tendonLigamentRotatorCuffDetails.withRepairAmount.amount`,
      maxBenefitNumber: `${parentPath}.tendonLigamentRotatorCuffDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.tendonLigamentRotatorCuffDetails.timePeriodCd`,
    },
    isGeneralAnesthesiaApplied: `${parentPath}.isGeneralAnesthesiaApplied`,
    generalAnesthesiaDetails: {
      incurralPeriod: `${parentPath}.generalAnesthesiaDetails.incurralPeriod`,
      benefitAmount: `${parentPath}.generalAnesthesiaDetails.benefitAmount.amount`,
      maxBenefitNumber: `${parentPath}.generalAnesthesiaDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.generalAnesthesiaDetails.timePeriodCd`,
    },
    isRupturedDiscApplied: `${parentPath}.isRupturedDiscApplied`,
    rupturedDiscDetails: {
      incurralPeriod: `${parentPath}.rupturedDiscDetails.incurralPeriod`,
      benefitAmount: `${parentPath}.rupturedDiscDetails.benefitAmount.amount`,
      maxBenefitNumber: `${parentPath}.rupturedDiscDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.rupturedDiscDetails.timePeriodCd`,
    },
    isBloodPlasmaPlateletsApplied: `${parentPath}.isBloodPlasmaPlateletsApplied`,
    bloodPlasmaPlateletsDetails: {
      incurralPeriod: `${parentPath}.bloodPlasmaPlateletsDetails.incurralPeriod`,
      benefitAmount: `${parentPath}.bloodPlasmaPlateletsDetails.benefitAmount.amount`,
      maxBenefitNumber: `${parentPath}.bloodPlasmaPlateletsDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.bloodPlasmaPlateletsDetails.timePeriodCd`,
    },
    isEyeInjuryApplied: `${parentPath}.isEyeInjuryApplied`,
    eyeInjuryDetails: {
      incurralPeriod: `${parentPath}.eyeInjuryDetails.incurralPeriod`,
      benefitAmount: `${parentPath}.eyeInjuryDetails.benefitAmount.amount`,
      maxBenefitNumber: `${parentPath}.eyeInjuryDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.eyeInjuryDetails.timePeriodCd`,
    },
  };
};
